"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateCarts = void 0;
const getCartTotal_1 = require("./getCartTotal");
const calculateCarts = (golf_line) => {
    let val = 0;
    // Carts
    if (golf_line?.carts?.enabled && golf_line?.carts?.payment_option !== null) {
        val = (0, getCartTotal_1.getCartTotal)(golf_line);
    }
    return val;
};
exports.calculateCarts = calculateCarts;
